module.exports = __webpack_public_path__ + "img/css.6827470e.svg";